import React from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { ButtonLink } from "Components/ReactstrapSlim";
import { brandingSelector } from "Utils/selectors";
import HeaderLogo from "./HeaderLogo";
import { SolutionsDropdown } from "./components";

interface HeaderLeftProps {
   className?: string;
   isSuperUser: boolean;
   isAuthenticated: boolean;
   isEnterpriseManagment?: boolean;
}
export const HeaderLeft: React.FC<HeaderLeftProps> = function ({ className, isSuperUser, isAuthenticated, isEnterpriseManagment }) {
   const branding = useSelector(brandingSelector);

   return <div className={classNames("header-left", className)}>
      <a className="skip-to-content-link" href="#wrapper" tabIndex={0}>
         Skip to content
      </a>
      <HeaderLogo isSuperUser={isSuperUser} isEnterpriseManagment={isEnterpriseManagment} branding={isSuperUser && !isEnterpriseManagment ? undefined : branding} />
      {
         isSuperUser || branding
            ? null
            : <div className="header-left-links">
               {
                  isAuthenticated
                     ? <>
                        <a href="/enterprise" className="btn btn-transparent header-btn-link">Enterprise</a>
                        <ButtonLink href="/pricing" className="btn btn-transparent header-btn-link">Pricing</ButtonLink>
                        <ButtonLink href="https://resources.liquidspace.com" className="btn btn-transparent header-btn-link">Resources</ButtonLink>                        
                     </>
                     : <>
                        <SolutionsDropdown />
                        <ButtonLink href="/how-it-works" className="btn btn-transparent header-btn-link">How it Works</ButtonLink>
                        <ButtonLink href="https://resources.liquidspace.com" className="btn btn-transparent header-btn-link">Resources</ButtonLink>
                        <ButtonLink href="/pricing" className="btn btn-transparent header-btn-link">Pricing</ButtonLink>
                     </>
               }
            </div>
      }
   </div>
}